import {ModalsCloseESB} from "@next/eventservice"

const modalsCloseESB = new ModalsCloseESB()

export const PublishToModalsClosed = () => {
    modalsCloseESB.publish()
}

export default {PublishToModalsClosed}
